module.exports = __webpack_public_path__ + "img/horizontal_7_6_pp3_8011.b770b814.png";